module.exports = __webpack_public_path__ + "img/temple_tech_Normal_ua.599eaa6a.webp";